<template>
    <div v-if="status == 0" class="status">
        <div class="status-inner">
            <h1 class="emoji title"><ion-icon name="sad-outline"></ion-icon></h1>
            <h2 class="h1 title text-center">We're closed.</h2>
            <p>We are no longer taking orders at the bar. For more information please talk to a member of staff.</p>

            <b-btn @click="reload" class="d-block ml-auto mr-auto" variant="danger" size="lg">Check again</b-btn>
        </div>
    </div>
</template>

<script>
    export default {
        name: "AppStatus",

        data(){
            return {
                status: 1,
            }
        },

        mounted() {
            this.getStatus()
        },

        methods: {
            getStatus() {
                axios.get('/settings/getOpenStatus').then(response => {
                    console.log('status')
                    this.status = response.data.status;
                    this.$emit('status', this.status)
                })
            },

            reload(){
                location.reload();
            }
        }
    }
</script>

<style scoped>

</style>
